import React from "react"
import { Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"

import {
  FiMapPin,
  FiCalendar,
  FiDollarSign,
  FiExternalLink,
} from "react-icons/fi"

import competitionStyles from "./competitions.module.scss"

const CompetitionPost = ({
  title,
  by,
  dateAndTime,
  address,
  price,
  website,
  excerpt,
  slug,
  imageData,
}) => {
  return (
    <div
      className={`${competitionStyles.postWrapper} ${competitionStyles.card}`}
    >
      <div className={competitionStyles.flex}>
        <BackgroundImage
          Tag="div"
          className={competitionStyles.postImage}
          fluid={imageData}
        />

        <div>
          <div className="competitionStyles headings">
            <h2>{title}</h2>
            {by ? <h3>{by}</h3> : null}
          </div>
          <div className={competitionStyles.cardInfo}>
            <p>
              <FiCalendar /> {dateAndTime}
            </p>
            <p>
              <FiMapPin /> {address}
            </p>
            <p>
              <FiDollarSign /> {price ? price : "Free"}
            </p>
          </div>
          {website ? (
            <a href={website}>
              <button>
                <FiExternalLink /> Website
              </button>
            </a>
          ) : null}

          <div
            className={competitionStyles.postContent}
            dangerouslySetInnerHTML={{ __html: excerpt }}
          />
          <Link to={`${slug}`} className={competitionStyles.readMore}>
            Read More
          </Link>
        </div>
      </div>
    </div>
  )
}

export default CompetitionPost
